import { ReactNode } from "react";
import { Card } from "@components/theming";
import { joinClassNames } from "@utils/helpers";

export default function TicketGateCard({
  children,
  hasSubdescription,
}: {
  children: ReactNode;
  hasSubdescription?: boolean;
}) {
  return (
    <Card
      sharedClasses={joinClassNames(
        "p-6",
        hasSubdescription ? "mt-10" : "mt-4"
      )}
      shopsiteClasses="bg-white border border-gray-200 rounded-xl"
      whitelabelClasses="max-sm:mb-6"
    >
      {children}
    </Card>
  );
}
